'use client';

import React, { useState } from 'react';

export default function SidebarTabWidget({ tocElement, newsElement }: { tocElement: React.ReactNode, newsElement: React.ReactNode }) {
  const [activeTab, setActiveTab] = useState<'toc' | 'news'>('toc');

  return (
    <div className="flex flex-col gap-0 border border-border bg-card/50 rounded-lg overflow-hidden">
      <div className="flex w-full border-b border-border bg-muted/20">
        <button
          onClick={() => setActiveTab('toc')}
          className={`flex-1 py-4 text-xs font-bold uppercase tracking-widest transition-colors ${
            activeTab === 'toc'
              ? 'border-b-2 border-brand text-brand bg-card'
              : 'text-muted-foreground hover:bg-muted/50'
          }`}
        >
          Table of Contents
        </button>
        <button
          onClick={() => setActiveTab('news')}
          className={`flex-1 py-4 text-xs font-bold uppercase tracking-widest transition-colors ${
            activeTab === 'news'
              ? 'border-b-2 border-brand text-brand bg-card'
              : 'text-muted-foreground hover:bg-muted/50'
          }`}
        >
          Latest News
        </button>
      </div>
      
      <div className="p-0 min-h-[500px]">
        <div className={activeTab === 'toc' ? 'block' : 'hidden'}>
          {tocElement}
        </div>
        <div className={activeTab === 'news' ? 'block p-6' : 'hidden'}>
          {newsElement}
        </div>
      </div>
    </div>
  );
}
